module.exports = __webpack_public_path__ + "static/antivol1-2f4bea047e0cc02f7302234d681951fc.jpg";